import { useState, useContext } from 'react';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ProveedorItem } from '../../../../services/api/proveedoresApi';
import { DarkModeContext } from '../../../../context/darkModeContext';
import './dataTableStyles.scss';
interface ProveedorDataTableProps {
  items: ProveedorItem[];
  columns: GridColDef[];
  onEdit: (item: ProveedorItem) => void;
  onDelete: (id: number) => void;
  onStatusChange: (id: number, active: boolean) => void;
  onAdd: () => void;
  isLoading: boolean;
}
const ProveedorDataTable = ({
  items,
  columns,
  onEdit,
  onDelete,
  onStatusChange,
  onAdd,
  isLoading
}: ProveedorDataTableProps) => {
  const [pageSize, setPageSize] = useState<number>(10);
  const { darkMode } = useContext(DarkModeContext);
  return (
    <Box className="datatable-container">
        <Box className="datatable-header">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAdd}
            className="add-button"
          >
            Agregar Nuevo
          </Button>
        </Box>
        <DataGrid
          rows={items}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          pagination
          checkboxSelection={false}
          disableSelectionOnClick
          autoHeight
          loading={isLoading}
          getRowId={(row) => row.Id}
          components={{
            Toolbar: GridToolbar
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          className="custom-datagrid"
          sx={{
            '& .MuiDataGrid-toolbarContainer': {
              padding: '16px',
              gap: '12px',
            },
          }}
        />
      </Box>
  );
};
export default ProveedorDataTable;